import PeopleCard from 'components/PeopleCard';
import {type NextPage} from 'next';
import {NextSeo} from 'next-seo';
import Claim from './layouts/Claim';
import Section from './layouts/Section';

const Index: NextPage = () => {
  return (
    <>
      <NextSeo title="About Us | Polar Signals" />

      <Claim
        title={<>About Us</>}
        subTitle={`Our aim at Polar Signals is to allow you to see what's underneath the iceberg. We firmly believe that performance and reliability are key features of any software.

Fast software is more enjoyable and productive to use. This reflects itself in numerous research findings where users frequently quit sites that are slow and conversion rates are higher the faster a system is.

At Polar Signals, it is our mission to allow everyone to build software that is fast, reliable and enjoyable to use.`}
        bgIcon="stripes"
        gradient={{
          topLeft: '#3fa4fe',
          topRight: '#a8e3f2',
          bottomLeft: '#4576ff',
          bottomRight: '#d2c0ff',
          center: '#8aadfe',
        }}
      ></Claim>

      <Section>
        <div className="grid grid-cols-12 pb-20">
          <div className="col-span-10 col-start-2">
            <h3>Meet the Team</h3>
            <div className="grid grid-cols-2 pt-10 sm:grid-cols-3 md:grid-cols-5">
              {[
                {
                  name: 'Frederic Branczyk',
                  description: 'Founder & CEO',
                  imagePath: '/team/frederic.jpg',
                },
                {
                  name: 'Thor Hansen',
                  description: 'Staff Software Engineer',
                  imagePath: '/team/thor.png',
                },
                {
                  name: 'Matthias Loibl',
                  description: 'Director of Cloud',
                  imagePath: '/team/matthias.jpg',
                },
                {
                  name: 'Yomi Eluwande',
                  description: 'Senior Software Engineer',
                  imagePath: '/team/yomi.png',
                },
                {
                  name: 'Manoj Vivek',
                  description: 'Senior Software Engineer',
                  imagePath: '/team/manoj.jpg',
                },
                {
                  name: 'Monica Wojciechowski',
                  description: 'Senior Software Engineer',
                  imagePath: '/team/monica.jpg',
                },
                {
                  name: 'Orawee "Jah" Junlaphan',
                  description: 'Executive Assistant',
                  imagePath: '/team/jah.jpg',
                },
                {
                  name: 'Alfonso Subiotto Marqués',
                  description: 'Staff Software Engineer',
                  imagePath: '/team/alfonso.jpg',
                },
                {
                  name: 'Tommy Reilly',
                  description: 'Staff Software Engineer',
                  imagePath: '/team/tommy.jpg',
                },
                {
                  name: 'Brennan Vincent',
                  description: 'Staff Software Engineer',
                  imagePath: '/team/brennan.jpg',
                },
                {
                  name: 'Kanika Sharma',
                  description: 'Senior Solutions Engineer',
                  imagePath: '/team/kanika.png',
                },
              ]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(item => (
                  <PeopleCard key={item.imagePath} {...item} />
                ))}
            </div>
          </div>
        </div>
      </Section>

      <Section>
        <div className="grid grid-cols-12">
          <div className="col-span-10 col-start-2">
            <h3>Investors</h3>

            <div className="grid grid-cols-2 pt-10 sm:grid-cols-3 md:grid-cols-5">
              {[
                {
                  name: 'Natalie Vais',
                  description: 'Spark Capital',
                  imagePath: '/investors/natalie-vais.jpg',
                },
                {
                  name: 'Dave Munichiello',
                  description: 'GV',
                  imagePath: '/investors/dave-munichiello.jpg',
                },
                {
                  name: 'Gaurav Gupta',
                  description: 'Lightspeed',
                  imagePath: '/investors/gaurav-gupta.jpg',
                },
                {
                  name: 'Nnamdi Iregbulem',
                  description: 'Lightspeed',
                  imagePath: '/investors/nnamdi-iregbulem.jpg',
                },
                {
                  name: 'Aashay Sanghvi ',
                  description: 'Haystack',
                  imagePath: '/investors/aashay-sanghvi.png',
                },
                {
                  name: 'Semil Shah',
                  description: 'Haystack',
                  imagePath: '/investors/semil-shah.jpg',
                },
                {
                  name: 'Stephan Cizmar',
                  description: 'Lorimer',
                  imagePath: '/investors/stephan-cizmar.png',
                },
              ].map(item => (
                <PeopleCard key={item.imagePath} {...item} />
              ))}
            </div>
          </div>
        </div>
      </Section>

      <Section>
        <div className="grid grid-cols-12">
          <div className="col-span-10 col-start-2">
            <h3>Angels & Advisors</h3>

            <div className="grid grid-cols-2 pt-10 sm:grid-cols-3 md:grid-cols-5">
              {[
                {
                  name: 'Alex Polvi',
                  description: 'Advisor & Investor',
                  imagePath: '/investors/alex-polvi.jpg',
                },
                {
                  name: 'Brandon Philips',
                  description: 'Investor',
                  imagePath: '/investors/brando-philips.jpg',
                },
                {
                  name: 'Bryan Liles',
                  description: 'Investor',
                  imagePath: '/investors/bryan-liles.jpg',
                },
                {
                  name: 'Erik Bernhardsson',
                  description: 'Modal Labs',
                  imagePath: '/investors/erik-bernhardsson.png',
                },
                {
                  name: 'Guillermo Rauch',
                  description: 'Vercel',
                  imagePath: '/investors/guillermo-rauch.jpg',
                },
                {
                  name: 'Jackson Georges',
                  description: 'Google',
                  imagePath: '/investors/jackson-georges.jpg',
                },
                {
                  name: 'Jason Scott',
                  description: 'Google',
                  imagePath: '/investors/jason-scott.jpg',
                },
                {
                  name: 'Jodi Goldberg',
                  description: 'Google',
                  imagePath: '/investors/jodi-goldberg.jpg',
                },
                {
                  name: 'John Thompson',
                  description: 'Microsoft',
                  imagePath: '/investors/john-thompson.jpg',
                },
                {
                  name: 'Julio Hansoul',
                  description: 'Google',
                  imagePath: '/investors/julio-hansoul.jpg',
                },
                {
                  name: 'Julius Volz',
                  description: 'PromLabs',
                  imagePath: '/investors/julius-volz.jpg',
                },
                {
                  name: 'Kemal Akkoyun',
                  description: 'Investor',
                  imagePath: '/investors/kemal-akkoyun.jpg',
                },
                {
                  name: 'Larry James Erwin',
                  description: 'Google',
                  imagePath: '/investors/larry-james-erwin.jpg',
                },
                {
                  name: 'Lili Cosic',
                  description: 'Advisor',
                  imagePath: '/investors/lili-cosic.jpg',
                },
                {
                  name: 'Nikhil Benesch',
                  description: 'Materialize',
                  imagePath: '/investors/nikhil-benesch.png',
                },
                {
                  name: 'Nisha George',
                  description: 'Investor',
                  imagePath: '/investors/nisha-george.png',
                },
                {
                  name: 'Monica Sarbu',
                  description: 'Xata',
                  imagePath: '/investors/monica-sarbu.png',
                },
                {
                  name: 'Rachel Palmer',
                  description: 'Google',
                  imagePath: '/investors/rachel-palmer.jpg',
                },
                {
                  name: 'Spencer Kimball',
                  description: 'CockroachLabs',
                  imagePath: '/investors/spencer-kimball.jpg',
                },
                {
                  name: 'Tauqeer Jamadar',
                  description: 'Investor',
                  imagePath: '/investors/tauqeer-jamadar.jpg',
                },
              ].map(item => (
                <PeopleCard key={item.imagePath} {...item} />
              ))}
            </div>
          </div>
        </div>
      </Section>
    </>
  );
};

export default Index;
